import { render } from "./BodyContent.vue?vue&type=template&id=504f9f64"
import script from "./BodyContent.vue?vue&type=script&lang=js"
export * from "./BodyContent.vue?vue&type=script&lang=js"

import "./BodyContent.vue?vue&type=style&index=0&id=504f9f64&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__